import { ref, computed } from "vue";

export const footerHeight = computed(() => `${4.2}dvh`);
